// ── JD statuses eligible for Role Reporting ──────────────────────────────────
export const ROLE_REPORTING_ELIGIBLE_STATUSES = [
  'PUBLISHED',
  'UNPUBLISHED',
  'GENERATED',
  'HUMAN-EDITED',
  'PENDING_APPROVAL',
];

// ── Pagination Defaults ───────────────────────────────────────────────────────
export const ROLE_REPORTING_PAGE_SIZE = 10;
export const ROLE_REPORTING_PAGE_SIZE_OPTIONS = ['10', '20', '30', '50'];

// ── Backend Error Codes ───────────────────────────────────────────────────────
export const ROLE_REPORTING_ERROR_CODES = {
  MISSING_PARAM: 7000,
  APEX_WITH_MANAGER: 7003,
  JOB_DESC_NOT_FOUND: 7004,
  SELF_REPORTING: 7005,
  REPORTING_CYCLE: 7006,
  QUERY_FAILED: 7040,
  UPDATE_FAILED: 7041,
  INTERNAL_ERROR: 7111,
};

// ── Messages ──────────────────────────────────────────────────────────────────
export const ROLE_REPORTING_MESSAGES = {
  LOAD_FAILED: 'Failed to load role reporting data',
  LOAD_FAILED_DESC: 'Unable to fetch job descriptions. Please try again.',
  SAVE_SUCCESS: 'Role reporting updated successfully',
  SAVE_FAILED: 'Failed to update role reporting',
  SAVE_FAILED_DESC: 'Unable to save the reporting change. Please try again.',
  NO_RECORDS: 'No active job descriptions found',
  ERR_APEX_WITH_MANAGER: 'A role marked apex cannot also have a reporting manager',
  ERR_SELF_REPORTING: 'A role cannot report to itself',
  ERR_REPORTING_CYCLE: 'This change would create a reporting cycle',
  ERR_NOT_FOUND: 'Not found',
  ERR_NOT_FOUND_DESC: 'The job description or proposed manager was not found.',
  ERR_SERVER: 'Server error',
  ERR_SERVER_DESC: 'An unexpected server error occurred. Please try again later.',
};
